function formatPixieNotifications(raw) {
  if (raw === 1 || raw === '1' || raw === true) return 'Yes';
  if (raw === 0 || raw === '0' || raw === false) return 'No';
  return '(unknown)';
}

module.exports = {
  formatPixieNotifications,
};
